var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/// <reference types="styled-components/cssprop" />
import React from "react";
import { ThemeProvider } from "styled-components";
import { Helmet } from "react-helmet";
import { colors } from "./colors";
import { fonts } from "./fonts";
import "./reset.css";
import { appCss } from "./appCss";
import { mediaQueries } from "./appCss/mediaQueries";
export const theme = { colors, fonts, css: appCss, mediaQueries };
export const Theme = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(ThemeProvider, Object.assign({ theme: theme }, props),
        React.createElement(Helmet, null,
            React.createElement("link", { rel: "preconnect", href: "https://fonts.googleapis.com" }),
            React.createElement("link", { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "" }),
            React.createElement("link", { href: "https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700&display=swap", rel: "stylesheet" })),
        children));
};
//# sourceMappingURL=index.js.map